import React, { useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import HowAreYouFeeling from '../../../questionnaire/cosmetic/how_are_you_feeling';
import ChooseAnOption from '../../../questionnaire/choose_an_option';
import YesNoExtra from '../../../questionnaire/yes_no_extra';

function Generic({ path, update, answeredFinalQuestion, history, conversationSurvey }) {
  const [rating, setRating] = useState('');
  const [comfortLevel, setComfortLevel] = useState('');
  const [confidenceLevel, setConfidenceLevel] = useState('');
  const [feelingNow, setFeelingNow] = useState('');
  const [isReadyForNextStep, setIsReadyForNextStep] = useState('');

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <HowAreYouFeeling
          title={`Rate the conversation with your mentor with ${conversationSurvey.patient_mentor_name}`}
          para="Your mentor won't see the rating. We want to make sure you're receiving the support you're looking for."
          answers={{ rating: rating }}
          numberRating={true}
          onSubmit={(answers) => {
            setRating(answers.rating);
            update({ rating: answers.rating });
            history.push(`${path}/comfort-level`);
          }}
          star={true}
          icons={[
            { text: 'Very disappointing' },
            { text: 'Disappointing' },
            { text: 'Somewhat helpful' },
            { text: 'Helpful' },
            { text: 'Very helpful' },
          ]}
          textLabels={['Very disappointing', 'Disappointing', 'Somewhat helpful', 'Helpful', 'Very helpful']}
          keyForAnswer={'rating'}
        />
      </Route>
      <Route exact path={`${path}/comfort-level`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setComfortLevel(answers.comfort_level);
            update({ data: { comfort_level: answers.comfort_level } });
            history.push(`${path}/confidence-level`);
          }}
          onBack={() => {
            history.push(`${path}`);
          }}
          answers={{ data: { comfort_level: comfortLevel } }}
          title={`My mentor made me feel more comfortable about seeking treatment for my condition.`}
          para={"We want to make sure your receiving the support you're looking for."}
          keyForAnswer={'comfort_level'}
          choices={['Strongly agree', 'Agree', 'Neither agree or disagree', 'Disagree', 'Strongly disagree']}
          showOther={false}
          selectOne
        />
      </Route>
      <Route exact path={`${path}/confidence-level`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setConfidenceLevel(answers.confidence_level);
            update({ data: { confidence_level: answers.confidence_level } });
            history.push(`${path}/feeling-now`);
          }}
          onBack={() => {
            history.push(`${path}/comfort-level`);
          }}
          answers={{ data: { confidence_level: confidenceLevel } }}
          title={`My mentor made me feel more confident working with ${conversationSurvey.surgeon_name}`}
          para={"We want to make sure your receiving the support you're looking for."}
          keyForAnswer={'confidence_level'}
          choices={['Strongly agree', 'Agree', 'Neither agree or disagree', 'Disagree', 'Strongly disagree']}
          showOther={false}
          selectOne
        />
      </Route>
      <Route exact path={`${path}/feeling-now`}>
        <HowAreYouFeeling
          title='How are you feeling about getting treatment now?'
          para='We want to make sure mentors are providing emotional support an guidance. '
          answers={{ data: { feeling_now: feelingNow } }}
          numberRating={true}
          onSubmit={(answers) => {
            setFeelingNow(answers.feeling_now);
            update({ data: { feeling_now: answers.feeling_now } });
            history.push(`${path}/next-step`);
          }}
          onBack={() => {
            history.push(`${path}/confidence-level`);
          }}
          icons={[
            { text: 'Very nervous' },
            { text: 'Nervous' },
            { text: 'Unsure' },
            { text: 'Excited' },
            { text: 'Very excited' },
          ]}
          textLabels={['Very Nervous', 'Nervous', 'Unsure', 'Excited', 'Very Excited']}
          keyForAnswer={'feeling_now'}
        />
      </Route>
      <Route exact path={`${path}/next-step`}>
        <div className={`row activity-question`}>
          <YesNoExtra
            onSubmit={(answers) => {
              setIsReadyForNextStep(answers.ready_for_next_step);
              answeredFinalQuestion({
                ready_for_next_step: answers.ready_for_next_step,
              });
              history.push(`${path}/thank-you`);
            }}
            onBack={() => {
              history.push(`${path}/feeling-now`);
            }}
            answers={{ ready_for_next_step: isReadyForNextStep }}
            title={`Are you ready to keep moving forward with your treatment or procedure?`}
            para={`Let us know if you're feeling prepared to take the next step on your journey.`}
            keyForAnswer={'ready_for_next_step'}
            ctaText='Submit'
            extraIndex={1}
          />
        </div>
      </Route>
    </Switch>
  );
}

export default Generic;
